import React,{useRef,useState,useEffect} from 'react';
import {DataTable,QuotationInfoCard} from '../../Components'
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";

import {NumberFormat,MobileFormat,DateThaiFormat,DateFormat,DateThai,GetRole} from '../../Utils/Function';
import moment from 'moment';
import DatePicker, { registerLocale } from "react-datepicker";
import { th } from 'date-fns/locale/th';
import "react-datepicker/dist/react-datepicker.css";
import { createRoot } from 'react-dom/client';
import {MemberInfoCard} from '../../Components/Member';
import Swal from 'sweetalert2';
import API from '../../API';
import '../../Assets/CSS/TALFC.css';
registerLocale('th', th);

const THAI_MONTHS = ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'];

const ThaiDayInput = React.forwardRef(({ onClick, selectedDate, placeholderText }, ref) => (
    <input
        className="form-control text-center"
        value={selectedDate ? `${String(selectedDate.getDate()).padStart(2,'0')} ${THAI_MONTHS[selectedDate.getMonth()]} ${selectedDate.getFullYear()+543}` : ''}
        onClick={onClick} onChange={()=>{}} ref={ref} readOnly placeholder={placeholderText}
    />
));

const ThaiDayHeader = ({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'4px 10px' }}>
        <button type="button" className="react-datepicker__navigation react-datepicker__navigation--previous" onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{position:'static'}}>{'<'}</button>
        <span className="react-datepicker__current-month">{THAI_MONTHS[date.getMonth()]} {date.getFullYear()+543}</span>
        <button type="button" className="react-datepicker__navigation react-datepicker__navigation--next" onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{position:'static'}}>{'>'}</button>
    </div>
);


const PageShiftList =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();

    const ref = useRef();
    const _MemberInfoCard = useRef();
    const [GroupList,setGroupList] = useState([]);

    const [_Date,setDate] = useState(new Date());
    const [_StaffList,setStaffList] = useState([]);
    const [_Footer,setFooter] = useState(null);
    useEffect(() => {
        (async () => {
            setValue("Date",new Date());
            _LoadStaffList();
        })();

        return ()=>{ }
    }, []);
   const _LoadStaffList = async()=>{
        setStaffList([]);
        API({method : "get",url:"/Staff/List"}).then(res=>{
                if (res.status !== 200) {
                    return;
                }
    
                if (!res.data.Status) {
                    return;
                }
                setStaffList(res.data.Data);
        }).catch(res => {
                return;
        });
    }
    const _configs = {
        "order": [[1, "desc"]],
        pageLength: 25,
        orderMulti: true
    }
    const _ajax  = {
        'url': '/Shift/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.UserID = getValues('UserID');
            const _D = moment(getValues('Date'));
            d.Date = _D.format("YYYY/MM/DD");
        },
        'dataSrc': function(json) {
            //console.log(json);
            setFooter(json.sql);
            return json.data;
        }
    };

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
            <button type='button' title='รายละเอียด' className='btn btn-info text-white' onClick={() => _MemberInfoCard.current?.Show(d)}>Info</button>

        </div>
    )
    const _column = [
        {data: "ShiftDate", name: "ShiftDate", autoWidth: true,render(data){
            return DateThaiFormat(data,false);
        }},
        {data: "ShiftTimeStart", name: "ShiftTimeStart", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        {data: "ShiftTimeEnd", name: "ShiftTimeEnd", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        { data: "Name", name: "Name", autoWidth: true },
        { data: "RemainingBalance", name: "RemainingBalance", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "IncomeBalance", name: "IncomeBalance", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "TopupBalance", name: "TopupBalance", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        {data: "Updated", name: "Updated", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        {
            data: "ShiftID", name: "ShiftID", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    
    const _UpdateTable =()=>{
        ref.current?.load();
    }

    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className='row mt-4'>
                    <div className='col-lg-12'>
                        <div className='card'>
                            <div className='card-header'>
                                <h3 className='card-title'>รายการรอบบัญชี</h3>
                            </div>
                            <div className='card-body' style={{'minHeight':'300px'}}>
                                <div className="row mt-2 mb-2 justify-content-end">
                                    <div className='col-12 col-lg-2'>
                                        <DatePicker
                                            selected={_Date}
                                            onChange={(date) => { setDate(date); setValue('Date',date); setTimeout(()=>{ref.current.load();},200); }}
                                            locale="th"
                                            selectsStart
                                            startDate={_Date}
                                            maxDate={new Date()}
                                            customInput={<ThaiDayInput selectedDate={_Date} />}
                                            renderCustomHeader={(props) => <ThaiDayHeader {...props} />}
                                        />
                                    </div>
                                    <div className='col-12 col-lg-3 text-end'>
                                        <div className='input-group float-end'>
                                            <select className='form-control text-center' {...register("UserID", { required: false })} defaultValue={0} onChange={(e)=>{setValue("UserID",e.target.value); setTimeout(()=>{ref.current.load();},200);}} >
                                                <option value={''} selected>ทั้งหมด</option>
                                                {_StaffList.map((v,i)=>(
                                                    <option key={i} value={v.UserID}>{v.Name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-lg-12 table-responsive">
                                        <table id="ShiftTableView" className='table w-100' role='grid'>
                                            <thead>
                                                <tr>
                                                    <th className="text-center textcenter">วันที่</th>
                                                    <th className="text-center textcenter">เริ่ม</th>
                                                    <th className="text-center textcenter">สิ้นสุด</th>
                                                    <th className="text-center textcenter">ชื่อเจ้าหน้าที่</th>
                                                    <th className="text-center textcenter">ยอดเงินคงเหลือ</th>
                                                    <th className="text-center textcenter">ยอดเงินสรุป</th>
                                                    <th className="text-center textcenter">ยอดเงินเติม</th>
                                                    <th className="text-center textcenter">วันที่แก้ไข</th>
                                                    <th className="text-center no-sort"></th>
                                                </tr>
                                            </thead>
                                            <DataTable TableID={"ShiftTableView"} Column={_column} Configs={_configs} ref={ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MemberInfoCard ref={_MemberInfoCard} />
        </React.Fragment>
        </>
    )
}

export default React.memo(PageShiftList)
